import { gql, useMutation, useQuery } from "@apollo/client";
import React, { useContext, useState } from "react";
import { useHistory, useRouteMatch } from "react-router";
import { FormContext } from "../../../../components/forms/FormContext";
import { TextInput } from "../../../../components/forms/TextInput";
import { BreadCrumb, BreadCrumbProp } from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import moment from "moment";
import { Graph } from "../../../../generated/graph";
import ReactTooltip from "react-tooltip";
import { Toast } from "src/hooks/toast";
import { ProductDraft } from "src/components/custom/ProductDraft";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import DatePicker from "react-datepicker";

const QUERY_BY_ID = gql`
  query sellerAdsCampaign($id: Int!) {
    sellerAdsCampaign(id: $id) {
      id
      name
      seller {
        id
        name
        contact
        origin
      }
      startDate
      endDate
      status
      items {
        biding
        budget
        status
        id
        product {
          id
          code
          thumbnail
        }
        salesQty
        salesAmount
        clicks
        clicksByApp
        clicksByWebsite
        liveAt
        liveUrl
        type
      }
    }
  }
`;

const MUTATION_CREATE_SELLER = gql`
  mutation createSellerAdsCampaign($data: SellerAdsCampaignInput!) {
    createSellerAdsCampaign(data: $data)
  }
`;

const MUTATTION_CREATE_SELLER_ITEM = gql`
  mutation createSellerAdsCampaignItem($campaignId: Int!, $data: SellerAdsCampaignItemInput!) {
    createSellerAdsCampaignItem(campaignId: $campaignId, data: $data)
  }
`;

interface PropsState {
  name?: string;
  startDate?: any | null;
  endDate?: any | null;
  productId?: string;
  biding?: string;
  budge?: string;
  type?: "LIVE" | "CLICK" | string;
}

function CreateSellerAdsCampaignComponent({ data, setData }: { data: PropsState; setData: (e: PropsState) => void }) {
  const context = useContext(FormContext);

  return (
    <div className="row">
      <div className="col-md-6">
        <TextInput
          className="form-control-sm form-secondary"
          label="Campaign Name"
          placeholder="Enter name here..."
          value={data.name!}
          onChange={(e) => setData({ ...data, name: e.target.value })}
          autoFocus
          name="name"
        />
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>
            Select Date
            <i className="fas fa-question-circle" data-tip data-for="date"></i>
            <ReactTooltip effect="solid" id="date">
              The date you would like the ads to run. Currently, campaign will not be ended by “End Date”.
              <br />
              Campaign keeps running until we serve all your given budget (PPC) or four days after product LIVE.
            </ReactTooltip>
          </label>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <DatePicker
              onChange={(e: any) => {
                setData({
                  ...data,
                  startDate: e,
                });
              }}
              value={data.startDate}
              selected={data.startDate}
              className={`form-control form-control-sm form-secondary ${
                context.error && context.error!.name === "date" ? "flash" : ""
              }`}
              showTimeSelect
              dateFormat="yyyy-MM-dd hh:mm:ss aa"
            />
            <i className="os-icon os-icon-minus2 ml-1 mr-1"></i>
            <DatePicker
              onChange={(e: any) => {
                if (data.startDate >= data.endDate) {
                  alert("End date must not less than start date.");
                }

                setData({
                  ...data,
                  endDate: e,
                });
              }}
              value={data.endDate}
              selected={data.endDate}
              className={`form-control form-control-sm form-secondary ${
                context.error && context.error!.name === "date" ? "flash" : ""
              }`}
              showTimeSelect
              dateFormat="yyyy-MM-dd hh:mm:ss aa"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export function AdsCampaignScreen() {
  const { push } = useHistory();
  const { params }: any = useRouteMatch();
  const [show, setShow] = useState(false);
  const [, setLoading] = useState(params.id === undefined ? false : true);
  const [items, setItems] = useState<any[]>([]);
  const [errorInput, setErrorInput] = useState({});
  const [biding, setBiding] = useState<any>("");
  const [budget, setBudget] = useState<any>("");
  const [type, setType] = useState("CLICK");
  const [data, setData] = useState<PropsState>({
    type: "CLICK",
    startDate: new Date(),
    endDate: new Date(),
  });

  const BreadCrumbItems: BreadCrumbProp[] = [
    {
      text: "Applications",
      to: "#",
    },
    {
      text: "Products",
      to: "#",
    },
    {
      text: "Ads Campaigns",
      to: "/products/campaign/list",
    },
    {
      text: params.id === undefined ? "Create" : "Duplicate",
      to: params.id === undefined ? "/product/ads/create" : "/product/ads/create" + params.id,
    },
  ];

  useQuery<Graph.Query>(QUERY_BY_ID, {
    fetchPolicy: "no-cache",
    skip: params.id === undefined,
    variables: {
      id: Number(params.id),
    },
    onCompleted: (response) => {
      setData({
        name: response.sellerAdsCampaign!.name!,
      });
      setItems(
        response.sellerAdsCampaign!.items!.map((x) => {
          return {
            id: x.product?.id,
            image: x.product?.thumbnail,
            biding: x.biding,
            budget: x.budget,
            type: x.type,
          };
        }),
      );
      setLoading(false);
    },
  });

  const [createSellerAdsCampaign] = useMutation(MUTATION_CREATE_SELLER, {
    refetchQueries: ["sellerAdsCampaigns", "sellerAdsCampaign"],
    onCompleted: (res) => {
      if (res.createSellerAdsCampaign) {
        for (let i = 0; i < items.length; i++) {
          createSellerAdsCampaignItem({
            variables: {
              campaignId: Number(res.createSellerAdsCampaign),
              data: {
                productId: Number(items[i].id),
                biding: Number(items[i].biding),
                budget: Number(items[i].budget),
                type: items[i].type,
              },
            },
          });
        }
      }
    },
  });
  const [createSellerAdsCampaignItem] = useMutation(MUTATTION_CREATE_SELLER_ITEM, {
    onCompleted: (res) => {
      if (res.createSellerAdsCampaignItem) {
        push("/products/campaign/list");
      }
    },
  });

  const handlerClick = () => {
    if (!data.name) {
      setErrorInput({
        error: { message: "", name: "name" },
      });
      return;
    }

    if (!data.startDate || !data.endDate) {
      setErrorInput({
        error: { message: "", name: "date" },
      });
      return;
    }

    if (biding < 0.02) {
      setErrorInput({
        error: { message: "", name: "biding" },
      });
      Toast.onShow("Minimum of biding limit 0.02!", "danger", "right");
      return;
    }

    if (budget < 1) {
      setErrorInput({
        error: { message: "", name: "budget" },
      });
      return;
    }

    if (data.startDate >= data.endDate) {
      alert("End date must not less than start date.");
      return;
    }

    for (let i = 0; i < items.length; i++) {
      if (items[i].biding < 0.02 || items[i].budget < 1) {
        alert("minimum of biding limit 0.02 and budget not allow input 0 value.");
        return;
      }
    }

    createSellerAdsCampaign({
      variables: {
        data: {
          name: data.name,
          startDate: moment(data.startDate).format("YYYY-MM-DD HH:mm:ss"),
          endDate: moment(data.endDate).format("YYYY-MM-DD HH:mm:ss"),
        },
      },
    });
  };

  return (
    <FormContext.Provider value={errorInput}>
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <ProductDraft
          show={show}
          setShow={setShow}
          items={items}
          setItems={(val: any[]) => {
            setItems(
              val.map((x) => {
                return {
                  ...x,
                  biding,
                  budget,
                  type,
                };
              }),
            );
          }}
        />
        <div className="row">
          <div className="col-md-6">
            <h5 className="mb-4">Create Ads Campaign</h5>
            <div className="element-wrapper pb-1">
              <div className="element-box">
                <CreateSellerAdsCampaignComponent data={data!} setData={setData} />
                <div className="row mb-2">
                  <div className="col-md-4">
                    <label>
                      Mass biding (USD)
                      <i className="fas fa-question-circle" data-tip data-for="biding"></i>
                      <ReactTooltip effect="solid" id="biding">
                        The amount you are willing to pay per product click (PPC) or per product sale (Product Live).
                        <br />
                        Higher biding will be selected to display at better placement (PPC) or to LIVE by well-known
                        models (product LIVE).
                        <br />
                        Currently, minimum biding for PPC is $0.01 and minimum biding for product LIVE is 16.88% of
                        sales price.
                      </ReactTooltip>
                    </label>
                    <TextInput
                      placeholder="mass biding here..."
                      className="form-control form-control-sm form-secondary"
                      type="number"
                      value={biding}
                      name="biding"
                      onChange={(e) => {
                        setBiding(e.target.value);
                        const x = items.map((i) => {
                          return {
                            ...i,
                            biding: e.target.value,
                          };
                        });
                        setItems(x);
                      }}
                      onBlur={() => {
                        if (Number(biding) < 0.02) {
                          setBiding(0.02);
                          const x = items.map((i) => {
                            return {
                              ...i,
                              biding: 0.02,
                            };
                          });
                          setItems(x);
                          Toast.onShow("Minimum biding is $0.02", "danger", "right");
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>
                      Mass budget (USD)
                      <i className="fas fa-question-circle" data-tip data-for="budget"></i>
                      <ReactTooltip effect="solid" id="budget">
                        The total budget you would to spend for each product of PPC campaign.
                        <br />
                        PPC campaign will be finished when it spent close to budget.
                        <br />
                        This budget is not accounted to product LIVE.
                      </ReactTooltip>
                    </label>
                    <TextInput
                      placeholder="mass budget here..."
                      className="form-control form-control-sm form-secondary"
                      type="number"
                      value={budget}
                      name="budget"
                      onChange={(e) => {
                        setBudget(e.target.value);
                        const x = items.map((i) => {
                          return {
                            ...i,
                            budget: e.target.value,
                          };
                        });
                        setItems(x);
                      }}
                      onBlur={() => {
                        if (Number(budget) < 1) {
                          setBudget(1);
                          const x = items.map((i) => {
                            return {
                              ...i,
                              budget: 1,
                            };
                          });
                          setItems(x);
                          Toast.onShow("Minimum budget is $1.", "danger", "right");
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>
                      Mass Type <i className="fas fa-question-circle" data-tip data-for="type"></i>
                      <ReactTooltip effect="solid" id="type">
                        You can choose between " Pay Per Click" and " Product Live" for your ads campaign.
                      </ReactTooltip>
                    </label>
                    <select
                      className="form-control form-control-sm form-secondary"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value="LIVE">Product Live</option>
                      <option value="CLICK">Pay Per Click</option>
                    </select>
                  </div>
                  <div className="col-md-12">
                    <small className="text-danger">
                      *** noted ***
                      <br />
                      <br />
                      <span>
                        <strong>Pay Per Click</strong>: Your product will be selected accordingly to your biding fee to
                        display on any screen of L192 app. <br /> The fee will be charged once customer clicks and views
                        your product.
                      </span>
                      <br />
                      <br />
                      <span>
                        <strong>Product Live</strong>: Your products can be selected to LIVE on L192 LIVE or L192 social
                        media pages, some products might not be selected to live due to biding fee. The fee will be
                        charged when product is ordered and ready to deliver.
                      </span>
                    </small>
                    <br />
                    {biding && budget && data.startDate < data.endDate && (
                      <button className="btn btn-sm btn-primary" onClick={() => setShow(true)}>
                        Choose Product
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <h5 className="mb-4">Campaign Item</h5>
            <div className="element-wrapper pb-1">
              <div className="element-box">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Biding (USD)</th>
                      <th>Budget (USD)</th>
                      <th>Type</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => {
                      return (
                        <CampaignField
                          key={index}
                          item={item}
                          setItem={(v: any) => {
                            let x = [...items];
                            x[index] = v;
                            setItems(x);
                          }}
                          onCancel={() => {
                            setLoading(true);
                            setItems(items.filter((item, i) => i !== index));
                            setTimeout(() => {
                              setLoading(false);
                            }, 500);
                          }}
                          mainBiding={biding}
                          mainBudget={budget}
                        />
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <button className="btn btn-sm btn-primary" onClick={handlerClick}>
              Submit
            </button>
          </div>
        </div>
      </Content>
    </FormContext.Provider>
  );
}

function CampaignField({
  item,
  setItem,
  onCancel,
  mainBiding,
  mainBudget,
}: {
  item: any;
  setItem: any;
  onCancel: any;
  mainBiding: number;
  mainBudget: number;
}) {
  return (
    <tr key={item.id}>
      <td>
        <img
          src={item.image}
          alt=""
          style={{
            width: 50,
            height: 50,
            borderRadius: 4,
            objectFit: "cover",
          }}
        />
      </td>
      <td>
        <input
          placeholder="Enter biding here..."
          className="form-control form-control-sm form-secondary"
          value={item.biding}
          onChange={(e) => {
            setItem({
              ...item,
              biding: Number(e.target.value),
            });
          }}
          onBlur={() => {
            if (Number(item.biding) < 0.02) {
              setItem({
                ...item,
                biding: mainBiding,
              });
              Toast.onShow("Minimum of biding limit $0.02", "danger", "right");
            }
          }}
          type="number"
          name="biding"
        />
      </td>
      <td>
        <input
          placeholder="Enter budget here..."
          className="form-control form-control-sm form-secondary"
          value={item.budget}
          onChange={(e) => {
            setItem({
              ...item,
              budget: Number(e.target.value),
            });
          }}
          onBlur={() => {
            if (Number(item.budget) < 1) {
              setItem({
                ...item,
                budget: mainBudget,
              });
              Toast.onShow("Minimum of budget limit $1", "danger", "right");
            }
          }}
          type="number"
          name="budget"
        />
      </td>
      <td>
        <select
          className="form-control form-control-sm form-secondary"
          value={item.type}
          onChange={(e) => {
            setItem({
              ...item,
              type: e.target.value,
            });
          }}
        >
          <option value="LIVE">Product Live</option>
          <option value="CLICK">Pay Per Click</option>
        </select>
      </td>
      <td>
        <button className="btn btn-danger btn-sm" onClick={() => onCancel()}>
          cancel
        </button>
      </td>
    </tr>
  );
}
